/* @flow */

import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import NavIconAdministration from './nav-icon-administration.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconAdministration {...validProps} />;
}
SvgComponent.iconName = 'navIconAdministration';

export const NavIconAdministrationIcon = svgIconWrapper(SvgComponent);
